import {
  createStore
} from 'framework7/lite';
import Cookies from 'js-cookie'
const store = createStore({
  state: {
    openId: null,
    token: null,
    tokenExpire: null,
    shop_Id: null,
    shopMode: null,
  },
  actions: {
    saveOpenId({
        state
      },
      data
    ) {
      state.openId = data;
      window.localStorage.setItem("OpenId", data);
    },
    saveShopId({
        state
      },
      data
    ) {
      state.shop_Id = data;
      window.localStorage.setItem("Shop_Id", data);
    },
    saveToken({
        state
      },
      data
    ) {
      state.token = data;
      window.localStorage.setItem("Token", data);
    },
    saveTokenExpire({
        state
      },
      data) {
      state.tokenExpire = data;
      window.localStorage.setItem("TokenExpire", data);
    },
    saveShopMode({
        state
      },
      data
    ) {
      state.shopMode = data;
      window.localStorage.setItem("ShopMode", data);
    },
    SET_LANGUAGE: ({
      state
    }, language) => {
      state.language = language
      Cookies.set('language', language)
    },

  },
})
export default store;